module.exports = __webpack_public_path__ + "static/img/yu3.e2d265f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7/yu3.png
// module id = LSBU
// module chunks = 0